export const INDEX = 14; // 7 = 86 Healthy

export const CLIENTS = [
  { // automation: pending
    index: 1,
    appIdIos: "com.diet.master",
    appIdAndroid: "com.diet.master",
    appVersionIos: 1,
    appVersionAndroid: 1,
    appName: "Eataami",
    identifier: "testing",
    appKeystoreFile: "",
    appKeystorePassword: "",
    appKeystoreAlias: "",
    appKeystoreAliasPassword: "",
  },
  { // automation: pending
    index: 2,
    appIdIos: "com.goabieta",
    appIdAndroid: "com.go.abieta",
    appVersionIos: 1,
    appVersionAndroid: 1,
    appName: "Abieta",
    identifier: "abietadm",
    appKeystoreFile: "abietadm.jks",
    appKeystorePassword: "Abieta@almerak2021",
    appKeystoreAlias: "abieta",
    appKeystoreAliasPassword: "Abieta@almerak2021",
  },
  { // automation: ready
    index: 3,
    appIdIos: "fit.dietmaster.thunders",
    appIdAndroid: "com.envisiondiet",
    appVersionIos: 245,
    appVersionAndroid: 245,
    appName: "XIV Restaurant",
    identifier: "xiv",
    appKeystoreFile: "envisiondm.jks",
    appKeystorePassword: "Envision@almerak2021",
    appKeystoreAlias: "Envision",
    appKeystoreAliasPassword: "Envision@almerak2021",
  },
  { // automation: pending
    index: 4,
    appIdIos: "com.dietcircle",
    appIdAndroid: "com.dietcircle",
    appVersionIos: 1,
    appVersionAndroid: 1,
    appName: "Diet Circle",
    identifier: "dietcircledm",
    appKeystoreFile: "dietcircledm.jks",
    appKeystorePassword: "dietcircle@almerak2023",
    appKeystoreAlias: "dietcircle@almerak2023",
    appKeystoreAliasPassword: "dietcircle@almerak2023",
  },
  { // automation: pending
    index: 5,
    appIdIos: "fit.dietmaster.eatsmart",
    appIdAndroid: "fit.dietmaster.eatsmart",
    appVersionIos: 203,
    appVersionAndroid: 203,
    appName: "Eat Smart KW",
    identifier: "eatsmart",
    appKeystoreFile: "eatsmart.jks",
    appKeystorePassword: "eatsmart@almerak2023",
    appKeystoreAlias: "eatsmart@almerak2023",
    appKeystoreAliasPassword: "eatsmart@almerak2023",
  },
  { // automation: pending
    index: 6,
    appIdIos: "fit.dietmaster.nutrilifedm",
    appIdAndroid: "fit.dietmaster.nutrilifedm",
    appVersionIos: 1,
    appVersionAndroid: 1,
    appName: "Nutri Life KSA",
    identifier: "nutrilifedm",
    appKeystoreFile: "nutrilife.jks",
    appKeystorePassword: "nutrilife@almerak2023",
    appKeystoreAlias: "nutrilife@almerak2023",
    appKeystoreAliasPassword: "nutrilife@almerak2023",
  },
  { // automation: pending
    index: 7,
    appIdIos: "fit.dietmaster.eightysixhealthy",
    appIdAndroid: "fit.dietmaster.eightysixhealthy",
    appVersionIos: 232,
    appVersionAndroid: 232,
    appName: "86 Healthy",
    identifier: "86healthy",
    appKeystoreFile: "86healthy.jks",
    appKeystorePassword: "86healthy@almerak2023",
    appKeystoreAlias: "86healthy@almerak2023",
    appKeystoreAliasPassword: "86healthy@almerak2023",
  },
  { // automation: pending
    index: 8,
    appIdIos: "com.diet.prep",
    appIdAndroid: "com.diet.prep",
    appVersionIos: 1,
    appVersionAndroid: 1,
    appName: "Prep Diet",
    identifier: "prepdiet",
    appKeystoreFile: "",
    appKeystorePassword: "",
    appKeystoreAlias: "",
    appKeystoreAliasPassword: "",
  },
  { // automation: pending
    index: 9,
    appIdIos: "fit.dietmaster.xdiet",
    appIdAndroid: "fit.dietmaster.xdiet",
    appVersionIos: 1,
    appVersionAndroid: 1,
    appName: "XDiet",
    identifier: "xdiet",
    appKeystoreFile: "",
    appKeystorePassword: "",
    appKeystoreAlias: "",
    appKeystoreAliasPassword: "",
  },

  { // automation: pending
    index: 10,
    appIdIos: "com.roots.diet",
    appIdAndroid: "com.roots.diet",
    appVersionIos: 1,
    appVersionAndroid: 1,
    appName: "Roots Diet",
    identifier: "roots",
    appKeystoreFile: "",
    appKeystorePassword: "",
    appKeystoreAlias: "",
    appKeystoreAliasPassword: "",
  },
  { // automation: pending
    index: 11,
    appIdIos: "com.ingest.diet",
    appIdAndroid: "com.ingest.diet",
    appVersionIos: 1,
    appVersionAndroid: 1,
    appName: "Ingest",
    identifier: "ingest",
    appKeystoreFile: "ingest@almerak2025.jks",
    appKeystorePassword: "ingest@almerak2025",
    appKeystoreAlias: "ingest@almerak2025",
    appKeystoreAliasPassword: "ingest@almerak2025",
  },
  { // automation: pending
    index: 12,
    appIdIos: "com.abietaqtr",
    appIdAndroid: "com.abietaqtr",
    appVersionIos: 1,
    appVersionAndroid: 1,
    appName: "Abieta Qtr",
    identifier: "abietaqtrdm",
    appKeystoreFile: "abietadm.jks",
    appKeystorePassword: "Abietaqtr@almerak2023",
    appKeystoreAlias: "Abietaqtr@almerak2023",
    appKeystoreAliasPassword: "Abietaqtr@almerak2023",
  },
  { // automation: pending
    index: 13,
    appIdIos: "com.notch.diet",
    appIdAndroid: "com.notch.diet",
    appVersionIos: 2,
    appVersionAndroid: 2,
    appName: "Notch Diet",
    identifier: "notchdiet",
    appKeystoreFile: "",
    appKeystorePassword: "",
    appKeystoreAlias: "",
    appKeystoreAliasPassword: "",
  },
  { // automation: pending
    index: 14,
    appIdIos: "com.diettime",
    appIdAndroid: "com.diettime",
    appVersionIos: 7,
    appVersionAndroid: 7,
    appName: "Diet Time",
    identifier: "diettime",
    appKeystoreFile: "",
    appKeystorePassword: "",
    appKeystoreAlias: "",
    appKeystoreAliasPassword: "",
  },
  { // automation: pending
    index: 21,
    appIdIos: "my.meals.online",
    appIdAndroid: "my.meals.online",
    appVersionIos: 2,
    appVersionAndroid: 2,
    appName: "Eataami testing",
    identifier: "testing",
    appKeystoreFile: "",
    appKeystorePassword: "",
    appKeystoreAlias: "",
    appKeystoreAliasPassword: "",
  },
];
